// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"139752ef","219":"f9321727","563":"74155b2f","617":"29f24936","825":"9e048184","935":"d1ccd8e3"}[chunkId] + ".chunk.js";
};